import { connect } from 'react-redux';

import { AppState } from '../../app/state/AppState';
import { MapStateToProps } from '../../app/utils/ConnectUtils';
import { AppRoot, AppRootOwnProps, AppRootStateProps } from './AppRoot';

export const mapStateToProps: MapStateToProps<AppRootStateProps> = (state: AppState) => ({
    rootAdminUiState: state.rootAdminUiState
  });

export const AppRootStateConnector: React.ComponentClass<AppRootOwnProps> = connect(mapStateToProps)(AppRoot);